import { Model } from '@/model/Model'
import { BaseState } from './BaseState'
import { IState } from './IStateMachine'
import { IStateMachine } from './IStateMachine'
import Facade from '@/Facade'

export class StateMachine implements IStateMachine {
    protected readonly _model: Model

    protected _currentState: BaseState
    protected _statesMap: Map<string, BaseState>
    protected _currentStateName: string

    public constructor(model: Model) {
        this._model = model

        this._currentState = null
        this._statesMap = new Map<string, BaseState>()
        this._currentStateName = null

        this.init()
    }

    public init() {
        // empty
    }

    public addState(stateType: IState, id: string) {
        if (this._statesMap.has(id)) {
            throw new Error('State already defined: ' + id)
        }

        this._statesMap.set(id, new stateType(this, this._model, id))
    }

    public setState(id: string) {
        if (this._currentState) {
            this._currentState.cleanUp()
        }

        this._currentState = this._statesMap.get(id)
        this._currentStateName = id
        this.applyState(id)

        Facade.currentState = id
        this._currentState.begin()
    }

    public applyState(id: string) {
        // empty
    }
}
